import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import enLocale from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enLocale,
      },
    },
    lng: localStorage.getItem('locale'),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });
